import EditionsIcon from '@atlaskit/icon-lab/core/editions';
import * as React from 'react';

export function SvgEditions(props) {
  return (
    <EditionsIcon
      label=""
      testId="ads-refreshed-icon"
      color={props.color ? props.color : 'currentColor'}
    />
  );
}
